module.exports = __webpack_public_path__ + "static/img/z2.6551e024.png";